import React from 'react';
import _ from 'underscore';

import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

export interface ScalarEnumSelectorInputProps {
  value: ScalarEnumOption | null;
  onChange: (newVal: ScalarEnumOption | null) => void;
  isEditable: boolean;
  scalarEnum: Array<ScalarEnumOption>;
  requiredConfig: boolean;
}

export default function ScalarEnumSelectorInput({
  value,
  isEditable,
  onChange,
  scalarEnum,
  requiredConfig,
}: ScalarEnumSelectorInputProps): JSX.Element {
  function getEnumDropdownOptions(
    scalarEnum: Array<ScalarEnumOption>
  ): Array<{value: ScalarEnumOption | null; name: string}> {
    let dropdownOptions: Array<{value: ScalarEnumOption | null; name: string}> = scalarEnum.map((option) => ({
      value: option,
      name: String(option),
    }));
    dropdownOptions = _.sortBy(dropdownOptions, 'name');
    if (!requiredConfig) {
      dropdownOptions.unshift({value: null, name: 'No option'});
    }
    return dropdownOptions;
  }

  return (
    <SelectDropdown
      displayName={value == null ? 'Select option' : String(value)}
      disabled={!isEditable}
      menu={
        <SearchableMenu
          onSelect={onChange}
          optionDatas={getEnumDropdownOptions(scalarEnum)}
          selectedValue={value}
        />
      }
    />
  );
}
